import { Badge } from '../../components/ui/display';

const UI = {
  COMPLETE: { tone: 'green', label: 'Complete' },
  PARTIAL: { tone: 'amber', label: 'Partial' },
  MISSING: { tone: 'rose', label: 'Missing' },
  NOT_EXPECTED: { tone: 'slate', label: 'Nothing expected' },
} as const;

export function CompletenessBadge({ status }: { status: keyof typeof UI }) {
  const ui = UI[status];
  return <Badge tone={ui.tone}>{ui.label}</Badge>;
}
